import User from "./User";
import { PaginationLink } from "./Pagination";

export default interface Event {
  eventID: number;
  name: string;
  excerpt: string;
  location: string;
  locationUrl: string;
  dateStart: Date;
  dateEnd: Date;
  allDayEvent: boolean;
  datePosted: Date;
  postUser: User;
  url: string;
  attending: string;
  ctaUrl?: string;
}

export interface EventPaginated {
  events: Array<Event>;
  pagination: Map<string, PaginationLink>;
}

export enum EventRSVP {
  Going = "Going",
  Maybe = "Maybe",
  NotGoing = "Not Going",
}

export enum EventFilter {
  Upcoming = "Upcoming Events",
  Past = "Event replays",
}

export enum sortFilter {
  All = "All",
  ThisWeek = "This Week",
  ThisMonth = "This Month",
  NextMonth = "Next Month",
}

export enum sortFilterUpcoming {
  All = "All",
  ThisWeek = "This Week",
  ThisMonth = "This Month",
  NextMonth = "Next Month",
}

export enum sortFilterReplay {
  All = "All",
  ThisWeek = "Last Week",
  ThisMonth = "This Month",
  NextMonth = "Last Month",
}

export enum onDemandEventFilter {
  Onboarding = "Onboarding",
  Implementation = "Implementation",
  Adoption = "Adoption",
  Success = "Success",
}
